// extracted by mini-css-extract-plugin
export const container = "Cta-module--container--Zd70z";
export const bg = "Cta-module--bg--3qa7h";
export const title = "Cta-module--title--3_Mck";
export const action = "Cta-module--action--2EWGY";
export const arrow = "Cta-module--arrow--1JGZ6";